<template>
  <article id="mainPage" class="main-page">
    <SectionAboveTheFold
      :isEnteringSectionMainView="isEnteringSectionMainView"
    />

    <SectionAdvantage
      :isEnteringSectionAdvantage="isEnteringSectionAdvantage"
    />

    <SectionJoinProfit
      :isEnteringSectionJoinProfit="isEnteringSectionJoinProfit"
    />

    <SectionPartnersFeedback
      :isEnteringSectionPartnersFeedback="isEnteringSectionPartnersFeedback"
    />

    <SectionProgramFeatures
      :isEnteringSectionProgramFeatures="isEnteringSectionProgramFeatures"
    />

    <SectionBecomeGanga7Partner
      :isEnteringSectionBecomeGanga7Partner="
        isEnteringSectionBecomeGanga7Partner
      "
      :contactLinkSetting="contactLinkSetting"
    />
  </article>
</template>

<script>
import SectionAboveTheFold from "@/components/SectionAboveTheFold.vue";
import SectionAdvantage from "@/components/SectionAdvantage.vue";
import SectionJoinProfit from "@/components/SectionJoinProfit.vue";
import SectionPartnersFeedback from "@/components/SectionPartnersFeedback.vue";
import SectionProgramFeatures from "@/components/SectionProgramFeatures.vue";
import SectionBecomeGanga7Partner from "@/components/SectionBecomeGanga7Partner.vue";

// *mobile-detect
import MobileDetect from "../../node_modules/mobile-detect/mobile-detect.min.js";

// *ScrollMagic
import ScrollMagic from "scrollmagic";

export default {
  name: "Home",

  components: {
    SectionAboveTheFold,
    SectionAdvantage,
    SectionJoinProfit,
    SectionPartnersFeedback,
    SectionProgramFeatures,
    SectionBecomeGanga7Partner,
  },

  data() {
    return {
      isMobile: undefined,
      isEnteringSectionMainView: false,
      isEnteringSectionAdvantage: false,
      isEnteringSectionJoinProfit: false,
      isEnteringSectionPartnersFeedback: false,
      isEnteringSectionProgramFeatures: false,
      isEnteringSectionBecomeGanga7Partner: false,
      contactLink: {
        // Group 1
        // "thefreelance.agency": {
        //   whatsApp: {
        //     link: "https://wa.me/message/RRW7LOVMEY6OK1",
        //     title: "Contact us through WhatsApp.",
        //   },
        //   telegram: {
        //     link: "https://t.me/gugobetagent",
        //     title: "Contact our Telegram. @kamall8588",
        //   },
        // },
        // "online-job.work": {
        //   whatsApp: {
        //     // link: "https://wa.me/message/RRW7LOVMEY6OK1",
        //     link: "",
        //     title: "Contact us through WhatsApp.",
        //   },
        //   telegram: {
        //     // link: "https://t.me/gugobetagent",
        //     link: "",
        //     title: "Contact our Telegram. @kamall8588",
        //   },
        // },
        // "alltimefreelance.info": {
        //   whatsApp: {
        //     link: "https://wa.me/message/QGRBPHYDMFKNI1",
        //     title: "Contact us through WhatsApp.",
        //   },
        //   telegram: {
        //     // link: "https://t.me/gugobetagent",
        //     link: "",
        //     title: "Contact our Telegram. @kamall8588",
        //   },
        // },
        // "beagentnow.online": {
        //   whatsApp: {
        //     link: "https://wa.me/message/GXLDXXWTZNXSN1",
        //     title: "Contact us through WhatsApp.",
        //   },
        //   telegram: {
        //     // link: "http://t.me/gugobetagent2",
        //     link: "",
        //     title: "Contact our Telegram. @kamall8588",
        //   },
        // },
        // "alltimemember.com": {
        //   whatsApp: {
        //     // link: "https://wa.me/message/RRW7LOVMEY6OK1",
        //     link: "",
        //     title: "Contact us through WhatsApp.",
        //   },
        //   telegram: {
        //     // link: "https://t.me/gugobetagent",
        //     link: "",
        //     title: "Contact our Telegram. @kamall8588",
        //   },
        // },

        // Group 2
        // "freepartner.online": {
        //   whatsApp: {
        //     link:
        //       "https://wa.me/886965720939?text=I%27m%20interested%20in%20earn%20money%20with%20gugobet",
        //     title: "Contact us through WhatsApp.",
        //   },
        //   telegram: {
        //     // link: "https://t.me/gugobetagent",
        //     link: "",
        //     title: "Contact our Telegram. @Devaraj_banda",
        //   },
        // },
      },
    };
  },

  computed: {
    contactLinkSetting() {
      const defaultSetting = {
        whatsApp: {
          link: "https://wa.me/message/7DPKGYO7UOV4P1",
          title: "Contact us through WhatsApp.",
        },
        telegram: {
          link: "https://t.me/OfficialGanga",
          title: "Contact our Telegram. @OfficialGanga",
        },
      };
      const { hostname } = window.location;
      let currentLinkSetting;

      Object.keys(this.contactLink).find((domain) => {
        if (hostname.includes(domain.trim())) {
          currentLinkSetting = this.contactLink[domain];
          return true;
        }
        return false;
      });

      return currentLinkSetting || defaultSetting;
    },
  },

  mounted() {
    // #是否為行動裝置
    this.isMobile = new MobileDetect(window.navigator.userAgent).mobile();
    this.initScrollMagic();
  },

  methods: {
    initScrollMagic() {
      // #ScrollMagic 初始化
      const scrollMagicController = new ScrollMagic.Controller();

      const ourAdvantageScene = new ScrollMagic.Scene({
        triggerElement: "#advantage",
        triggerHook: this.isMobile ? 0.5 : 0.6,
        duration: "100%",
      }).addTo(scrollMagicController);

      ourAdvantageScene.on("enter", () => {
        this.isEnteringSectionAdvantage = true;
      });

      const joinProfitScene = new ScrollMagic.Scene({
        triggerElement: "#join-profit",
        triggerHook: this.isMobile ? 0.5 : 0.6,
        duration: "100%",
      }).addTo(scrollMagicController);

      joinProfitScene.on("enter", () => {
        this.isEnteringSectionJoinProfit = true;
      });

      const successStoriesScene = new ScrollMagic.Scene({
        triggerElement: "#partners-feedback",
        triggerHook: this.isMobile ? 0.5 : 0.6,
        duration: "100%",
      }).addTo(scrollMagicController);

      successStoriesScene.on("enter", () => {
        this.isEnteringSectionPartnersFeedback = true;
      });

      const programFeaturesScene = new ScrollMagic.Scene({
        triggerElement: "#program-features",
        triggerHook: this.isMobile ? 0.5 : 0.6,
        duration: "100%",
      }).addTo(scrollMagicController);

      programFeaturesScene.on("enter", () => {
        this.isEnteringSectionProgramFeatures = true;
      });

      const becomeGanga7sPartner = new ScrollMagic.Scene({
        triggerElement: "#become-ganga7s-partner",
        triggerHook: this.isMobile ? 1 : 0.6,
        duration: "100%",
      }).addTo(scrollMagicController);

      becomeGanga7sPartner.on("enter", () => {
        this.isEnteringSectionBecomeGanga7Partner = true;
      });

      this.isEnteringSectionMainView = true;
    },
  },
};
</script>
